import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import { TBiofouling2Place } from '../@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';

export type TBFL2D1Item1 = {
    descriptionOfAnyObservedReduction: string;
};

export type TBFL2D1Item2 = {
    descriptionOfOperationBeyond: string;
};

export type TBFL2D1Item3 = {
    locationOfAnyInstances: string;
};

export type TBFL2D1Item4 = {
    recordsOfMaintenance: string;
    maintenanceAttachment: string;
};

export type TBFL2D1Item5 = {
    contingencyActions: string;
};

export type TBFL2D1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2D1;
        item1: TBFL2D1Item1;
        item2: TBFL2D1Item2;
        item3: TBFL2D1Item3;
        item4: TBFL2D1Item4;
        item5: TBFL2D1Item5;
    };

export type TBFL2D = TBFL2D1;

const BFL2D_DEFAULTS: {
    D1: TBFL2D1;
} = {
    D1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            descriptionOfAnyObservedReduction: '',
        },
        item2: {
            descriptionOfOperationBeyond: '',
        },
        item3: {
            locationOfAnyInstances: '',
        },
        item4: {
            recordsOfMaintenance: '',
            maintenanceAttachment: ' ',
        },
        item5: {
            contingencyActions: '',
        },
        recordCode: EBFL2RecordCode.BFL2D1,
    },
};

export { BFL2D_DEFAULTS };
